/**
 * What the signed-in person may open among the shell's own screens, from the roles their token
 * carries — the same mechanism «User management» uses (`hasGrants`, ADR 9014). Navigation, not
 * security: the platform refuses the triage reads to anyone without `feedback_triage`.
 */

import { useMemo } from 'react';

import { hasGrants, useAccessGrants } from '../../auth/grants';
import { ADMIN_USERS_REQUIRES } from '../routes/admin/constants';
import { FEEDBACK_TRIAGE_REQUIRES } from '../routes/feedback/constants';

export interface ShellAccess {
  /** Holds `administrator`: User management and User activity. */
  readonly administers: boolean;
  /** Holds `feedback_triage`: the report triage screen. */
  readonly triages: boolean;
}

export function useShellAccess(): ShellAccess {
  const { realmRoles } = useAccessGrants();
  return useMemo(() => ({
    administers: hasGrants(ADMIN_USERS_REQUIRES, realmRoles),
    triages: hasGrants(FEEDBACK_TRIAGE_REQUIRES, realmRoles),
  }), [realmRoles]);
}
